import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 align-items-center" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "collapse show" }
const _hoisted_9 = { class: "card-body border-top p-9" }
const _hoisted_10 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_11 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_12 = { class: "col-lg-8 fv-row" }
const _hoisted_13 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_16 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_17 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_18 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_25 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_26 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_27 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_33 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_34 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_35 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_36 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = {
  key: 2,
  class: "row mb-6"
}
const _hoisted_42 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_43 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_44 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_45 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = {
  key: 3,
  class: "row mb-6"
}
const _hoisted_51 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_52 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_53 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_54 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_57 = { class: "fv-plugins-message-container" }
const _hoisted_58 = { class: "fv-help-block" }
const _hoisted_59 = {
  key: 4,
  class: "row mb-6"
}
const _hoisted_60 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_61 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_62 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_63 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_64 = { class: "row" }
const _hoisted_65 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_66 = { class: "fv-plugins-message-container" }
const _hoisted_67 = { class: "fv-help-block" }
const _hoisted_68 = {
  key: 5,
  class: "row mb-6"
}
const _hoisted_69 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_70 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_71 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_72 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_75 = { class: "fv-plugins-message-container" }
const _hoisted_76 = { class: "fv-help-block" }
const _hoisted_77 = {
  key: 6,
  class: "row mb-6"
}
const _hoisted_78 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_79 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_80 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_81 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_82 = { class: "row" }
const _hoisted_83 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_84 = { class: "fv-plugins-message-container" }
const _hoisted_85 = { class: "fv-help-block" }
const _hoisted_86 = {
  key: 0,
  class: "card"
}
const _hoisted_87 = { class: "card-header border-0 align-items-center" }
const _hoisted_88 = { class: "card-title m-0" }
const _hoisted_89 = { class: "fw-bolder m-0" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = {
  key: 1,
  class: "collapse show"
}
const _hoisted_93 = { class: "card-body border-top p-9" }
const _hoisted_94 = { class: "row mb-6" }
const _hoisted_95 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_96 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_97 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_98 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_99 = { class: "row" }
const _hoisted_100 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_101 = { class: "fv-plugins-message-container" }
const _hoisted_102 = { class: "fv-help-block" }
const _hoisted_103 = { class: "row mb-6" }
const _hoisted_104 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_105 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_106 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_107 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_108 = { class: "row" }
const _hoisted_109 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_110 = { class: "fv-plugins-message-container" }
const _hoisted_111 = { class: "fv-help-block" }
const _hoisted_112 = { class: "row mb-6" }
const _hoisted_113 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_114 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_115 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_116 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_117 = { class: "row" }
const _hoisted_118 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_119 = { class: "fv-plugins-message-container" }
const _hoisted_120 = { class: "fv-help-block" }
const _hoisted_121 = { class: "row mb-6" }
const _hoisted_122 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_123 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_124 = {
  key: 0,
  class: "col-lg-12 col-form-label fw-bold fs-6"
}
const _hoisted_125 = {
  key: 1,
  class: "col-lg-12 col-form-label fw-bold fs-6"
}
const _hoisted_126 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_127 = { class: "row" }
const _hoisted_128 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_129 = { class: "fv-plugins-message-container" }
const _hoisted_130 = { class: "fv-help-block" }
const _hoisted_131 = { class: "row mb-6" }
const _hoisted_132 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_133 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_134 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_135 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_136 = { class: "row" }
const _hoisted_137 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_138 = { class: "fv-plugins-message-container" }
const _hoisted_139 = { class: "fv-help-block" }
const _hoisted_140 = { class: "row mb-6" }
const _hoisted_141 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_142 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_143 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_144 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_145 = { class: "row" }
const _hoisted_146 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_147 = { class: "fv-plugins-message-container" }
const _hoisted_148 = { class: "fv-help-block" }
const _hoisted_149 = { class: "row mb-6" }
const _hoisted_150 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_151 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_152 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_153 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_154 = { class: "row" }
const _hoisted_155 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_156 = { class: "fv-plugins-message-container" }
const _hoisted_157 = { class: "fv-help-block" }
const _hoisted_158 = {
  key: 2,
  class: "card"
}
const _hoisted_159 = { class: "card-header border-0 align-items-center" }
const _hoisted_160 = { class: "card-title m-0" }
const _hoisted_161 = { class: "fw-bolder m-0" }
const _hoisted_162 = { key: 0 }
const _hoisted_163 = { key: 1 }
const _hoisted_164 = {
  key: 3,
  class: "collapse show"
}
const _hoisted_165 = { class: "card-body border-top p-9" }
const _hoisted_166 = { class: "row mb-6" }
const _hoisted_167 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_168 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_169 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_170 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_171 = { class: "row" }
const _hoisted_172 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_173 = { class: "fv-plugins-message-container" }
const _hoisted_174 = { class: "fv-help-block" }
const _hoisted_175 = { class: "row mb-6" }
const _hoisted_176 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_177 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_178 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_179 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_180 = { class: "row" }
const _hoisted_181 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_182 = { class: "fv-plugins-message-container" }
const _hoisted_183 = { class: "fv-help-block" }
const _hoisted_184 = { class: "row mb-6" }
const _hoisted_185 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_186 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_187 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_188 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_189 = { class: "row" }
const _hoisted_190 = { class: "col-lg-12 fv-row fv-plugins-icon-container" }
const _hoisted_191 = { class: "fv-plugins-message-container" }
const _hoisted_192 = { class: "fv-help-block" }

import { showBackendError } from "@/assets/ts/_utils/ShowBackendError";
import CurrencyInput from "@/components/widgets/CurrencyInput.vue";
import { diffObjects } from "@/core/helpers/diffObjects";
import { ProyectosN2Listado } from "@/store/models";
import {
  AuthModule,
  MunicipiosModule,
  ProyectosN2ListadoModule,
} from "@/store/modules";
import { ElNotification } from "element-plus";
import Swal from "sweetalert2";
import { ErrorMessage, useField, useForm } from "vee-validate";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import * as Yup from "yup";

interface FormState {
  codigo?: string | null;
  proyectoPadreId: string;
  denominacion: string;
  descripcion?: string | null;
  bolsaCuidadosEnabled?: boolean | null;
  creacionEmpleoEnabled?: boolean | null;
  planFormacionEnabled?: boolean | null;
  entidadResponsable?: string | null;
  formulaGestionContrato?: string | null;
  fechaPuestaMarcha?: string | null;

  municipiosIds?: number[] | null;

  objetivosGenerales?: string | null;
  objetivosEspecificos?: string | null;
  descripcionAcciones?: string | null;
  importe?: number | null;
  viasFinanciacion?: string | null;
  duracionAcciones?: string | null;
  localizacionAcciones?: string | null;

  gradoAlcanceObjetivos?: string | null;
  dificultadesEncontradas?: string | null;
  propuestasFuturas?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const store = useStore();
const module = getModule(ProyectosN2ListadoModule, store);
const municipiosModule = getModule(MunicipiosModule, store);
const authModule = getModule(AuthModule, store);

const comarcaId = authModule.user.comarcaId;
const route = useRoute();
const token = route.params.id as string;

const proyectoN2 = computed(() => module.proyectoN2);
const municipios = computed(() => municipiosModule.municipios);

const editingInfoProyectoN2 = ref<boolean>(false);
const editingDetallesProyectoN2 = ref<boolean>(false);
const editingValoracionProyectoN2 = ref<boolean>(false);
const creandoProyectoN2 = ref<boolean>(false) ? !token : true;
//const cargaDetalle = ref<boolean>(false); animacion de carga

const mostrarFecha = (fecha) => {
  if (!fecha) return "-";

  if (fecha instanceof Date) {
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const anio = fecha.getFullYear();
    return `${dia}/${mes}/${anio}`;
  }

  const [anio, mes, dia] = fecha.split("/");
  if (anio && mes && dia) {
    return `${dia}/${mes}/${anio}`;
  }

  return fecha;
};
const schema = Yup.object({
  codigo: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.codigo.label")),
  proyectoPadreId: Yup.string()
    .required()
    .label(t("formularios.proyectoN2Detalle.proyectoPadreId.label")),
  denominacion: Yup.string()
    .required()
    .label(t("formularios.proyectoN2Detalle.denominacion.label")),
  descripcion: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.descripcion.label")),
  bolsaCuidadosEnabled: Yup.boolean()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.categoria.cuidados")),
  creacionEmpleoEnabled: Yup.boolean()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.categoria.empleo")),
  planFormacionEnabled: Yup.boolean()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.categoria.formacion")),
  entidadResponsable: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.entidadResponsable.label")),
  formulaGestionContrato: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.formulaGestionContrato.label")),
  fechaPuestaMarcha: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.fechaPuestaMarcha.label")),

  objetivosGenerales: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.objetivosGenerales.label")),
  objetivosEspecificos: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.objetivosEspecificos.label")),
  descripcionAcciones: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.descripcionAcciones.label")),
  importe: Yup.number()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.importe.label")),
  viasFinanciacion: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.viasFinanciacion.label")),
  duracionAcciones: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.duracionAcciones.label")),
  localizacionAcciones: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.localizacionAcciones.label")),
  municipiosIds: Yup.array().nullable().label(t("proyecto.municipiosLabel")),
  gradoAlcanceObjetivos: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.gradoAlcanceObjetivos.label")),
  dificultadesEncontradas: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.dificultadesEncontradas.label")),
  propuestasFuturas: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.propuestasFuturas.label")),
});

const { resetForm, handleSubmit, meta } = useForm<Partial<FormState>>({
  validationSchema: schema,
});

const guardaDetalle = ref<boolean>(false);
const guardarProyectoN2 = handleSubmit(async (values) => {
  guardaDetalle.value = true;

  const update: Partial<ProyectosN2Listado> = diffObjects(
    meta.value.initialValues,
    values
  );

  if (update.importe) {
    update.importe = parseFloat(update.importe.toString());
  }
  if (Object.keys(update).length) {
    await module
      .updateById({
        id: token,
        comarcaId: comarcaId,
        proyectoN2: {
          ...update,
        },
      })
      .then(() => {
        ElNotification({
          message: t("formularios.proyectosN2.guardar.mensaje.exito"),
          type: "success",
        });
        editingInfoProyectoN2.value = false;
        editingDetallesProyectoN2.value = false;
        editingValoracionProyectoN2.value = false;
        module.fetchById({ comarcaId: comarcaId, id: token as string });
      })
      .catch((err) => {
        if (typeof err === "object" && err?.error?.statusCode < 500) {
          showBackendError(t, err.error);
        } else {
          ElNotification({
            message: t("formularios.proyectosN2.cargar.error"),
            type: "error",
          });
        }
      })
      .finally(() => {
        guardaDetalle.value = false;
      });
  } else {
    ElNotification({
      message: t("formularios.proyectosN2.guardar.mensaje.exito"),
      type: "success",
    });
    editingInfoProyectoN2.value = false;
    editingDetallesProyectoN2.value = false;
    editingValoracionProyectoN2.value = false;
    module.fetchById({ comarcaId: comarcaId, id: token as string });

    guardaDetalle.value = false;
  }
});

//Categorias del proyecto
const categoriaProyecto = computed(() => {
  let tipoProyectos: string[] = [];
  if (proyectoN2.value?.bolsaCuidadosEnabled) {
    tipoProyectos.push(t("formularios.proyectoN2Detalle.categoria.cuidados"));
  }
  if (proyectoN2.value?.creacionEmpleoEnabled) {
    tipoProyectos.push(t("formularios.proyectoN2Detalle.categoria.empleo"));
  }
  if (proyectoN2.value?.planFormacionEnabled) {
    tipoProyectos.push(t("formularios.proyectoN2Detalle.categoria.formacion"));
  }
  if (
    proyectoN2.value?.bolsaCuidadosEnabled === false &&
    proyectoN2.value?.creacionEmpleoEnabled === false &&
    proyectoN2.value?.planFormacionEnabled === false
  ) {
    tipoProyectos.push("-");
  }
  return tipoProyectos.join("\n");
});

//Lista de municipios del proyecto
const municipiosListado = computed(() => {
  return proyectoN2.value?.municipios?.map((m) => m.nombre).join(", ") ?? "-";
});

const municipiosFiltrados = computed(() => {
  return [...municipios.value].sort((a, b) =>
    a.nombre.localeCompare(b.nombre, "es", { sensitivity: "base" })
  );
});

const crearProyectoN2 = handleSubmit(async (values) => {
  guardaDetalle.value = true;
  try {
    const proyectoN2Crear = {
      proyectoPadreId: values.proyectoPadreId,
      denominacion: values.denominacion,
    };

    await module.crear({
      proyectoN2Crear: proyectoN2Crear,
      comarcaId: comarcaId,
    });

    await Swal.fire({
      text: t("formularios.proyectosN2.crear.mensaje.exito"),
      icon: "success",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: { confirmButton: "btn btn-primary" },
    });

    router.replace("/listados/proyectosN2");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    if (err?.error?.statusCode < 500) {
      showBackendError(t, err.error);
    } else {
      Swal.fire({
        text: t("formularios.proyectosN2.crear.mensaje.error"),
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: t("dialogs.okButton"),
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    }
  }
  guardaDetalle.value = false;
});

onMounted(async () => {
  try {
    await municipiosModule.fetch();
  } catch (error) {
    console.error("Error fetching municipios:", error);
  }

  if (!token) {
    resetForm({
      values: {
        codigo: "",
        proyectoPadreId: "",
        denominacion: "",
        descripcion: "",
        entidadResponsable: "",
        formulaGestionContrato: "",
        fechaPuestaMarcha: null,
        bolsaCuidadosEnabled: false,
        creacionEmpleoEnabled: false,
        planFormacionEnabled: false,

        municipiosIds: null,

        objetivosGenerales: "",
        objetivosEspecificos: "",
        descripcionAcciones: "",
        importe: 0,
        viasFinanciacion: "",
        duracionAcciones: null,
        localizacionAcciones: "",

        gradoAlcanceObjetivos: "",
        dificultadesEncontradas: "",
        propuestasFuturas: "",
      },
    });
  }
});

watch(proyectoN2, () => {
  if (!proyectoN2.value) return;

  resetForm({
    values: {
      codigo: proyectoN2.value.codigo,
      proyectoPadreId: proyectoN2.value.proyectoPadreId,
      denominacion: proyectoN2.value.denominacion,
      descripcion: proyectoN2.value.descripcion,
      entidadResponsable: proyectoN2.value.entidadResponsable,
      formulaGestionContrato: proyectoN2.value.formulaGestionContrato,
      fechaPuestaMarcha: proyectoN2.value.fechaPuestaMarcha,
      bolsaCuidadosEnabled: proyectoN2.value.bolsaCuidadosEnabled,
      creacionEmpleoEnabled: proyectoN2.value.creacionEmpleoEnabled,
      planFormacionEnabled: proyectoN2.value.planFormacionEnabled,

      objetivosGenerales: proyectoN2.value.objetivosGenerales,
      objetivosEspecificos: proyectoN2.value.objetivosEspecificos,
      descripcionAcciones: proyectoN2.value.descripcionAcciones,
      importe: proyectoN2.value.importe ?? 0,
      viasFinanciacion: proyectoN2.value.viasFinanciacion,
      duracionAcciones: proyectoN2.value.duracionAcciones,
      localizacionAcciones: proyectoN2.value.localizacionAcciones,

      gradoAlcanceObjetivos: proyectoN2.value.gradoAlcanceObjetivos,
      dificultadesEncontradas: proyectoN2.value.dificultadesEncontradas,
      propuestasFuturas: proyectoN2.value.propuestasFuturas,

      municipiosIds: proyectoN2.value.municipios
        ? proyectoN2.value.municipios.map((m) => m.id)
        : [],
    },
  });
});

const { value: proyectoPadreId } = useField("proyectoPadreId");
const { value: denominacion } = useField("denominacion");
const { value: descripcion } = useField("descripcion");
const { value: entidadResponsable } = useField("entidadResponsable");
const { value: formulaGestionContrato } = useField("formulaGestionContrato");
const { value: fechaPuestaMarcha } = useField("fechaPuestaMarcha");
const { value: bolsaCuidadosEnabled } = useField("bolsaCuidadosEnabled");
const { value: creacionEmpleoEnabled } = useField("creacionEmpleoEnabled");
const { value: planFormacionEnabled } = useField("planFormacionEnabled");

const { value: objetivosGenerales } = useField("objetivosGenerales");
const { value: objetivosEspecificos } = useField("objetivosEspecificos");
const { value: descripcionAcciones } = useField("descripcionAcciones");
const { value: importe } = useField("importe");
const { value: viasFinanciacion } = useField("viasFinanciacion");
const { value: duracionAcciones } = useField("duracionAcciones");
const { value: localizacionAcciones } = useField("localizacionAcciones");

const { value: gradoAlcanceObjetivos } = useField("gradoAlcanceObjetivos");
const { value: dificultadesEncontradas } = useField("dificultadesEncontradas");
const { value: propuestasFuturas } = useField("propuestasFuturas");

const { value: municipiosIds } = useField("municipiosIds");

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("formulario.proyecto.resumen.titulo")), 1)
        ]),
        (!editingInfoProyectoN2.value && !_unref(creandoProyectoN2))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
            (editingInfoProyectoN2.value = true),
              (editingDetallesProyectoN2.value = false),
              (editingValoracionProyectoN2.value = false)
          ))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.editar.button")), 1)
                ]),
                _: 1
              })
            ]))
          : (_unref(creandoProyectoN2))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _unref(crearProyectoN2),
                  loading: guardaDetalle.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.crear.button")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"]),
                _createVNode(_component_el_button, {
                  onClick: _ctx.$router.back
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.cancelar.button")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _unref(guardarProyectoN2),
                  loading: guardaDetalle.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.guardar.button")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"]),
                _createVNode(_component_el_button, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (editingInfoProyectoN2.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.cancelar.button")), 1)
                  ]),
                  _: 1
                })
              ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (!_unref(creandoProyectoN2))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.codigo.label")), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(proyectoN2)?.codigo ?? "-"), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.proyectoPadreId.label")), 1),
          (!editingInfoProyectoN2.value && !_unref(creandoProyectoN2))
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(proyectoN2)?.proyectoPadreId ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_el_input, {
                      type: "text",
                      name: "proyectoPadreId",
                      placeholder: "",
                      modelValue: _unref(proyectoPadreId),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(proyectoPadreId) ? (proyectoPadreId).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_unref(ErrorMessage), { name: "proyectoPadreId" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.denominacion.label")), 1),
          (!editingInfoProyectoN2.value && !_unref(creandoProyectoN2))
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(proyectoN2)?.denominacion ?? "-"), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_el_input, {
                      type: "text",
                      name: "denominacion",
                      placeholder: " ",
                      modelValue: _unref(denominacion),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(denominacion) ? (denominacion).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_unref(ErrorMessage), { name: "denominacion" })
                      ])
                    ])
                  ])
                ])
              ]))
        ]),
        (!_unref(creandoProyectoN2))
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.descripcion.label")), 1),
              (!editingInfoProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(proyectoN2)?.descripcion ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_el_input, {
                          rows: 3,
                          autosize: { minRows: 3 },
                          type: "textarea",
                          placeholder: " ",
                          modelValue: _unref(descripcion),
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(descripcion) ? (descripcion).value = $event : null))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_unref(ErrorMessage), { name: "descripcion" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (!_unref(creandoProyectoN2))
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.categoria.label")), 1),
              (!editingInfoProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("label", _hoisted_44, _toDisplayString(_unref(categoriaProyecto) ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_el_checkbox, {
                          name: "bolsaCuidadosEnabled",
                          modelValue: _unref(bolsaCuidadosEnabled),
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(bolsaCuidadosEnabled) ? (bolsaCuidadosEnabled).value = $event : null))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.categoria.cuidados")), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_el_checkbox, {
                          name: "creacionEmpleoEnabled",
                          modelValue: _unref(creacionEmpleoEnabled),
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(creacionEmpleoEnabled) ? (creacionEmpleoEnabled).value = $event : null))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.categoria.empleo")), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_el_checkbox, {
                          name: "planFormacionEnabled",
                          modelValue: _unref(planFormacionEnabled),
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(planFormacionEnabled) ? (planFormacionEnabled).value = $event : null))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.categoria.formacion")), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_unref(ErrorMessage), { name: "categoria" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (!_unref(creandoProyectoN2))
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.municipios.label")), 1),
              (!editingInfoProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("label", _hoisted_53, _toDisplayString(_unref(municipiosListado)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _unref(municipiosIds),
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(municipiosIds) ? (municipiosIds).value = $event : null)),
                          filterable: "",
                          multiple: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(municipiosFiltrados), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.nombre,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            _createVNode(_unref(ErrorMessage), { name: "municipiosIds" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (!_unref(creandoProyectoN2))
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.entidadResponsable.label")), 1),
              (!editingInfoProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    _createElementVNode("label", _hoisted_62, _toDisplayString(_unref(proyectoN2)?.entidadResponsable ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "entidadResponsable",
                          placeholder: " ",
                          modelValue: _unref(entidadResponsable),
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(entidadResponsable) ? (entidadResponsable).value = $event : null))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createVNode(_unref(ErrorMessage), { name: "entidadResponsable" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (!_unref(creandoProyectoN2))
          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
              _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.formulaGestionContrato.label")), 1),
              (!editingInfoProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _createElementVNode("label", _hoisted_71, _toDisplayString(_unref(proyectoN2)?.formulaGestionContrato ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "formulaGestionContrato",
                          placeholder: " ",
                          modelValue: _unref(formulaGestionContrato),
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(formulaGestionContrato) ? (formulaGestionContrato).value = $event : null))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createVNode(_unref(ErrorMessage), { name: "formulaGestionContrato" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        (!_unref(creandoProyectoN2))
          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
              _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.fechaPuestaMarcha.label")), 1),
              (!editingInfoProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                    _createElementVNode("label", _hoisted_80, _toDisplayString(_unref(proyectoN2)?.fechaPuestaMarcha ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _unref(fechaPuestaMarcha),
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(fechaPuestaMarcha) ? (fechaPuestaMarcha).value = $event : null)),
                          type: "date",
                          placeholder: mostrarFecha(_unref(proyectoN2)?.fechaPuestaMarcha),
                          format: "DD/MM/YYYY",
                          "value-format": "DD/MM/YYYY",
                          class: "datePicker w-100"
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createVNode(_unref(ErrorMessage), { name: "fechaPuestaMarcha" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (!_unref(creandoProyectoN2))
      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("h3", _hoisted_89, _toDisplayString(_ctx.$t("formulario.proyecto.detalles.titulo")), 1)
            ]),
            (!editingDetallesProyectoN2.value && !_unref(creandoProyectoN2))
              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (
            (editingDetallesProyectoN2.value = true),
              (editingValoracionProyectoN2.value = false),
              (editingInfoProyectoN2.value = false)
          ))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.editar.button")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_91, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _unref(guardarProyectoN2),
                    loading: guardaDetalle.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.guardar.button")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"]),
                  _createVNode(_component_el_button, {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (editingDetallesProyectoN2.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.cancelar.button")), 1)
                    ]),
                    _: 1
                  })
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(creandoProyectoN2))
      ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.objetivosGenerales.label")), 1),
              (!editingDetallesProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                    _createElementVNode("label", _hoisted_97, _toDisplayString(_unref(proyectoN2)?.objetivosGenerales ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, [
                        _createVNode(_component_el_input, {
                          rows: 3,
                          autosize: { minRows: 3 },
                          type: "textarea",
                          name: "objetivosGenerales",
                          placeholder: "",
                          modelValue: _unref(objetivosGenerales),
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(objetivosGenerales) ? (objetivosGenerales).value = $event : null))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_101, [
                          _createElementVNode("div", _hoisted_102, [
                            _createVNode(_unref(ErrorMessage), { name: "objetivosGenerales" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.objetivosEspecificos.label")), 1),
              (!editingDetallesProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                    _createElementVNode("label", _hoisted_106, _toDisplayString(_unref(proyectoN2)?.objetivosEspecificos ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_107, [
                    _createElementVNode("div", _hoisted_108, [
                      _createElementVNode("div", _hoisted_109, [
                        _createVNode(_component_el_input, {
                          rows: 3,
                          autosize: { minRows: 3 },
                          type: "textarea",
                          name: "objetivosEspecificos",
                          placeholder: "",
                          modelValue: _unref(objetivosEspecificos),
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(objetivosEspecificos) ? (objetivosEspecificos).value = $event : null))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_110, [
                          _createElementVNode("div", _hoisted_111, [
                            _createVNode(_unref(ErrorMessage), { name: "objetivosEspecificos" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("label", _hoisted_113, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.descripcionAcciones.label")), 1),
              (!editingDetallesProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                    _createElementVNode("label", _hoisted_115, _toDisplayString(_unref(proyectoN2)?.descripcionAcciones ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_116, [
                    _createElementVNode("div", _hoisted_117, [
                      _createElementVNode("div", _hoisted_118, [
                        _createVNode(_component_el_input, {
                          rows: 3,
                          autosize: { minRows: 3 },
                          type: "textarea",
                          name: "descripcionAcciones",
                          placeholder: "",
                          modelValue: _unref(descripcionAcciones),
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(descripcionAcciones) ? (descripcionAcciones).value = $event : null))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_119, [
                          _createElementVNode("div", _hoisted_120, [
                            _createVNode(_unref(ErrorMessage), { name: "descripcionAcciones" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("label", _hoisted_122, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.importe.label")), 1),
              (!editingDetallesProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                    (_unref(proyectoN2)?.importe != null)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_124, _toDisplayString(Number(_unref(proyectoN2)?.importe).toLocaleString("es-ES", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
                useGrouping: true,
              })), 1))
                      : (_openBlock(), _createElementBlock("label", _hoisted_125, _toDisplayString("0€")))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_126, [
                    _createElementVNode("div", _hoisted_127, [
                      _createElementVNode("div", _hoisted_128, [
                        _createVNode(CurrencyInput, {
                          modelValue: _unref(importe),
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(importe) ? (importe).value = $event : null)),
                          modelModifiers: { lazy: true },
                          options: {
                  currency: 'EUR',
                  locale: 'es-ES',
                  currencyDisplay: 'symbol',
                  precision: 2,
                  hideCurrencySymbolOnFocus: true,
                  hideGroupingSeparatorOnFocus: true,
                  hideNegligibleDecimalDigitsOnFocus: true,
                  autoDecimalDigits: false,
                  useGrouping: true,
                  accountingSign: false,
                },
                          type: "text",
                          name: "importe",
                          class: "form-control form-control-lg",
                          placeholder: "ej. 11000.21"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_129, [
                          _createElementVNode("div", _hoisted_130, [
                            _createVNode(_unref(ErrorMessage), { name: "ingresos" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.viasFinanciacion.label")), 1),
              (!editingDetallesProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                    _createElementVNode("label", _hoisted_134, _toDisplayString(_unref(proyectoN2)?.viasFinanciacion ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_135, [
                    _createElementVNode("div", _hoisted_136, [
                      _createElementVNode("div", _hoisted_137, [
                        _createVNode(_component_el_input, {
                          rows: 3,
                          autosize: { minRows: 3 },
                          type: "textarea",
                          name: "viasFinanciacion",
                          placeholder: "",
                          modelValue: _unref(viasFinanciacion),
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(viasFinanciacion) ? (viasFinanciacion).value = $event : null))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_138, [
                          _createElementVNode("div", _hoisted_139, [
                            _createVNode(_unref(ErrorMessage), { name: "viasFinanciacion" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_140, [
              _createElementVNode("label", _hoisted_141, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.duracionAcciones.label")), 1),
              (!editingDetallesProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                    _createElementVNode("label", _hoisted_143, _toDisplayString(_unref(proyectoN2)?.duracionAcciones ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_144, [
                    _createElementVNode("div", _hoisted_145, [
                      _createElementVNode("div", _hoisted_146, [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _unref(duracionAcciones),
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(duracionAcciones) ? (duracionAcciones).value = $event : null)),
                          type: "date",
                          placeholder: mostrarFecha(_unref(proyectoN2)?.duracionAcciones),
                          format: "DD/MM/YYYY",
                          "value-format": "DD/MM/YYYY",
                          class: "datePicker w-100"
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("div", _hoisted_147, [
                          _createElementVNode("div", _hoisted_148, [
                            _createVNode(_unref(ErrorMessage), { name: "duracionAcciones" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_149, [
              _createElementVNode("label", _hoisted_150, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.localizacionAcciones.label")), 1),
              (!editingDetallesProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                    _createElementVNode("label", _hoisted_152, _toDisplayString(_unref(proyectoN2)?.localizacionAcciones ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_153, [
                    _createElementVNode("div", _hoisted_154, [
                      _createElementVNode("div", _hoisted_155, [
                        _createVNode(_component_el_input, {
                          rows: 3,
                          autosize: { minRows: 3 },
                          type: "textarea",
                          name: "localizacionAcciones",
                          placeholder: "",
                          modelValue: _unref(localizacionAcciones),
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_isRef(localizacionAcciones) ? (localizacionAcciones).value = $event : null))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_156, [
                          _createElementVNode("div", _hoisted_157, [
                            _createVNode(_unref(ErrorMessage), { name: "localizacionAcciones" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(creandoProyectoN2))
      ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
          _createElementVNode("div", _hoisted_159, [
            _createElementVNode("div", _hoisted_160, [
              _createElementVNode("h3", _hoisted_161, _toDisplayString(_ctx.$t("formulario.proyecto.valoracion.titulo")), 1)
            ]),
            (!editingValoracionProyectoN2.value && !_unref(creandoProyectoN2))
              ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (
            (editingValoracionProyectoN2.value = true),
              (editingDetallesProyectoN2.value = false),
              (editingInfoProyectoN2.value = false)
          ))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.editar.button")), 1)
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_163, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _unref(guardarProyectoN2),
                    loading: guardaDetalle.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.guardar.button")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"]),
                  _createVNode(_component_el_button, {
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (editingValoracionProyectoN2.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("formularios.organismo.cancelar.button")), 1)
                    ]),
                    _: 1
                  })
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(creandoProyectoN2))
      ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
          _createElementVNode("div", _hoisted_165, [
            _createElementVNode("div", _hoisted_166, [
              _createElementVNode("label", _hoisted_167, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.gradoAlcanceObjetivos.label")), 1),
              (!editingValoracionProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                    _createElementVNode("label", _hoisted_169, _toDisplayString(_unref(proyectoN2)?.gradoAlcanceObjetivos ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_170, [
                    _createElementVNode("div", _hoisted_171, [
                      _createElementVNode("div", _hoisted_172, [
                        _createVNode(_component_el_input, {
                          rows: 3,
                          autosize: { minRows: 3 },
                          type: "textarea",
                          name: "gradoAlcanceObjetivos",
                          placeholder: "",
                          modelValue: _unref(gradoAlcanceObjetivos),
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_isRef(gradoAlcanceObjetivos) ? (gradoAlcanceObjetivos).value = $event : null))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_173, [
                          _createElementVNode("div", _hoisted_174, [
                            _createVNode(_unref(ErrorMessage), { name: "gradoAlcanceObjetivos" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_175, [
              _createElementVNode("label", _hoisted_176, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.dificultadesEncontradas.label")), 1),
              (!editingValoracionProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                    _createElementVNode("label", _hoisted_178, _toDisplayString(_unref(proyectoN2)?.dificultadesEncontradas ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_179, [
                    _createElementVNode("div", _hoisted_180, [
                      _createElementVNode("div", _hoisted_181, [
                        _createVNode(_component_el_input, {
                          rows: 3,
                          autosize: { minRows: 3 },
                          type: "textarea",
                          name: "dificultadesEncontradas",
                          placeholder: "",
                          modelValue: _unref(dificultadesEncontradas),
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_isRef(dificultadesEncontradas) ? (dificultadesEncontradas).value = $event : null))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_182, [
                          _createElementVNode("div", _hoisted_183, [
                            _createVNode(_unref(ErrorMessage), { name: "dificultadesEncontradas" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_184, [
              _createElementVNode("label", _hoisted_185, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.propuestasFuturas.label")), 1),
              (!editingValoracionProyectoN2.value && !_unref(creandoProyectoN2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                    _createElementVNode("label", _hoisted_187, _toDisplayString(_unref(proyectoN2)?.propuestasFuturas ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_188, [
                    _createElementVNode("div", _hoisted_189, [
                      _createElementVNode("div", _hoisted_190, [
                        _createVNode(_component_el_input, {
                          rows: 3,
                          autosize: { minRows: 3 },
                          type: "textarea",
                          name: "propuestasFuturas",
                          placeholder: "",
                          modelValue: _unref(propuestasFuturas),
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_isRef(propuestasFuturas) ? (propuestasFuturas).value = $event : null))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_191, [
                          _createElementVNode("div", _hoisted_192, [
                            _createVNode(_unref(ErrorMessage), { name: "propuestasFuturas" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})